"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var decorateActionMenuChildren = function decorateActionMenuChildren(children, handleClose) {
  var childList = null;
  if (children) {
    childList = _react.default.Children.toArray(children).map(function (child, index) {
      if (! /*#__PURE__*/_react.default.isValidElement(child)) {
        return child;
      }

      // Header isn't interactive, and should be disabled automatically
      // if top element is a Header, disable headerDivider automatically
      if (child.props.variant === 'Header') {
        if (index === 0) {
          return /*#__PURE__*/_react.default.cloneElement(child, {
            headerDivider: false,
            disabled: true
          });
        } else {
          return /*#__PURE__*/_react.default.cloneElement(child, {
            disabled: true
          });
        }
      } else {
        return /*#__PURE__*/_react.default.cloneElement(child, {
          handleClose: handleClose
        });
      }
    });
  }
  return childList;
};
var _default = exports.default = decorateActionMenuChildren;